/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Assign_Venue_SavedInputs */

const th_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`กำหนดสนามแล้ว`)
};

const en_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Venue assigned.`)
};

const ja_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`会場を割り当てました。`)
};

const zh_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已指派场馆。`)
};

const es_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pabellón asignado.`)
};

const pt_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ginásio definido.`)
};

const id_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat ditetapkan.`)
};

const fr_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salle attribuée.`)
};

const tl_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Naitalaga ang venue.`)
};

const vi_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã phân địa điểm.`)
};

const ko_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기장을 배정했습니다.`)
};

const de_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Halle zugewiesen.`)
};

const ru_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Площадка назначена.`)
};

const tr_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Salon atandı.`)
};

const it_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impianto assegnato.`)
};

const pl_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hala przypisana.`)
};

const uk_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Майданчик призначено.`)
};

const hi_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्थल तय हो गया।`)
};

const ar_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تم تعيين الصالة.`)
};

const ms_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempat ditetapkan.`)
};

const bn_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`মাঠ নির্ধারিত হয়েছে।`)
};

const zh_tw2_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已指派場館。`)
};

const zh_hk2_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`已指派場館。`)
};

const ur_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقام مقرر ہو گیا۔`)
};

const fa_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`سالن تعیین شد.`)
};

const sw_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ukumbi umepangwa.`)
};

const nl_assign_venue_saved = /** @type {(inputs: Assign_Venue_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaal toegewezen.`)
};

/**
* | output |
* | --- |
* | "Venue assigned." |
*
* @param {Assign_Venue_SavedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const assign_venue_saved = /** @type {((inputs?: Assign_Venue_SavedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Assign_Venue_SavedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_assign_venue_saved(inputs)
	if (locale === "ja") return ja_assign_venue_saved(inputs)
	if (locale === "zh") return zh_assign_venue_saved(inputs)
	if (locale === "es") return es_assign_venue_saved(inputs)
	if (locale === "pt") return pt_assign_venue_saved(inputs)
	if (locale === "id") return id_assign_venue_saved(inputs)
	if (locale === "fr") return fr_assign_venue_saved(inputs)
	if (locale === "tl") return tl_assign_venue_saved(inputs)
	if (locale === "vi") return vi_assign_venue_saved(inputs)
	if (locale === "ko") return ko_assign_venue_saved(inputs)
	if (locale === "de") return de_assign_venue_saved(inputs)
	if (locale === "ru") return ru_assign_venue_saved(inputs)
	if (locale === "tr") return tr_assign_venue_saved(inputs)
	if (locale === "it") return it_assign_venue_saved(inputs)
	if (locale === "pl") return pl_assign_venue_saved(inputs)
	if (locale === "uk") return uk_assign_venue_saved(inputs)
	if (locale === "hi") return hi_assign_venue_saved(inputs)
	if (locale === "ar") return ar_assign_venue_saved(inputs)
	if (locale === "ms") return ms_assign_venue_saved(inputs)
	if (locale === "bn") return bn_assign_venue_saved(inputs)
	if (locale === "zh-TW") return zh_tw2_assign_venue_saved(inputs)
	if (locale === "zh-HK") return zh_hk2_assign_venue_saved(inputs)
	if (locale === "ur") return ur_assign_venue_saved(inputs)
	if (locale === "fa") return fa_assign_venue_saved(inputs)
	if (locale === "sw") return sw_assign_venue_saved(inputs)
	if (locale === "nl") return nl_assign_venue_saved(inputs)
	return en_assign_venue_saved(inputs)
});